export class Assign {
    AssignId?: string; // 名前
    assignCd?: string; // 名前
    act: number; // アクセス (1.表示, 2.編集, 99.管理)
    teamCd: string;
    staffCd: string;
    delflg?: number;
}
